module.exports = __webpack_public_path__ + "img/volume-down.336b3a8c.svg";